import api from './api';

// Les crides d'administració. Totes exigeixen un testimoni d'algú amb `role='admin'`: qui no
// n'és rep un 403 del servidor, i amagar la pantalla al frontend no és cap protecció —és
// comoditat—. La protecció és el `router.use(authenticate, authorize('admin'))` del backend.
const adminService = {
  summary: async () => (await api.get('/admin/summary')).data,
  pending: async () => (await api.get('/admin/pending')).data,
  users: async () => (await api.get('/admin/users')).data,

  approve: async (id, role) => (await api.post(`/admin/users/${id}/approve`, { role })).data,
  reject: async (id) => (await api.post(`/admin/users/${id}/reject`)).data,
  setRole: async (id, role) => (await api.post(`/admin/users/${id}/role`, { role })).data,
  // De quin docent és cada persona. És el que decideix qui veu els models de qui, ara que les
  // organitzacions no s'usen: un instructor veu els models dels seus alumnes.
  setInstructor: async (id, instructorId) =>
    (await api.post(`/admin/users/${id}/instructor`, { instructorId })).data,

  resets: async () => (await api.get('/admin/resets')).data,
  // Torna el codi EN CLAR, i és l'única vegada que existeix. Qui ho cridi l'ha d'ensenyar
  // immediatament: no es pot tornar a demanar.
  issue: async (id) => (await api.post(`/admin/resets/${id}/issue`)).data,
  resetFor: async (userId) => (await api.post(`/admin/users/${userId}/reset`)).data,
  dismiss: async (id) => (await api.delete(`/admin/resets/${id}`)).data,

  // ESBORRAR UN COMPTE. Sense `que`, el servidor contesta 409 amb quants models té i no toca
  // res: és així a posta, perquè `models.creator_id` és ON DELETE CASCADE i esborrar a seques
  // s'enduria la feina d'aquella persona en silenci.
  //   que = 'transfereix'  els models passen a qui esborra
  //   que = 'esborra'      el compte i els models se'n van tots
  deleteUser: async (id, que) =>
    (await api.delete(`/admin/users/${id}${que ? `?models=${que}` : ''}`)).data,
};

export default adminService;
